import { BadgeColor } from 'shared/ui/ServerTable/RowBadge';
import { ContractItemPriceRaiseStatus } from '../../model/types';

export const priceRaiseStatusLabelMap: Record<ContractItemPriceRaiseStatus, string> = {
  [ContractItemPriceRaiseStatus.ACCEPTED]: 'Accepted',
  [ContractItemPriceRaiseStatus.REJECTED]: 'Rejected',
  [ContractItemPriceRaiseStatus.REVIEW_AGAIN]: 'Review again',
  [ContractItemPriceRaiseStatus.COMPLETED]: 'Completed',
  [ContractItemPriceRaiseStatus.UNFINISHED]: 'Unfinished',
};

export const priceRaiseStatusBadgeColorMap: Record<ContractItemPriceRaiseStatus, BadgeColor> = {
  [ContractItemPriceRaiseStatus.ACCEPTED]: 'accent',
  [ContractItemPriceRaiseStatus.REJECTED]: 'error',
  [ContractItemPriceRaiseStatus.REVIEW_AGAIN]: 'warn',
  [ContractItemPriceRaiseStatus.COMPLETED]: 'success',
  [ContractItemPriceRaiseStatus.UNFINISHED]: 'error',
};
